import { useQuery } from "@tanstack/react-query";
import { readInventoryChangeDetail } from "../../../../../api/inventory/InvApi";
import { invHistoryInit } from "../state";

type Props = {
  id: number;
};

export const useReadInventoryChangeDetail = ({ id }: Props) => {
  const { data } = useQuery({
    queryKey: ["readInventoryChangeDetail", id],
    queryFn: async () => await readInventoryChangeDetail(id),
    select: (res) =>
      res?.data.result?.inventoryChangeRecordRes ?? invHistoryInit,
    enabled: id !== 0,
  });

  return { data };
};
